




import { defineComponent, onBeforeUnmount, onMounted, watch, PropType, nextTick, ref } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    id: {
      type: String as PropType<string>,
      default: null,
    },
    options: {
      type: Object as PropType<IntersectionObserverInit>,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const defaultOptions: IntersectionObserverInit = { rootMargin: '250px' };
    const options: Partial<IntersectionObserverInit> = Object.assign(defaultOptions, props.options);

    const observer = ref<IntersectionObserver>(null);
    const rootEl = ref<HTMLDivElement>(null);

    const callback = (entry: IntersectionObserverEntry) => {
      if (entry && entry.isIntersecting)
        emit('intersect');
    };

    const teardown = () => {
      if (observer.value)
        observer.value.disconnect();
    };

    const setup = () => {
      teardown();

      observer.value = new IntersectionObserver(
        ([entry]) => callback(entry),
        options,
      );

      // Observe future intersections
      observer.value.observe(rootEl.value);
    };

    const show = ref(true);
    const flush = async () => {
      teardown();

      // Re-mount div to trigger new intersection
      show.value = false;
      await nextTick();
      show.value = true;
      await nextTick();

      setup();
    };

    onMounted(setup);
    watch(() => props.id, flush);
    onBeforeUnmount(teardown);

    return {
      rootEl,
      show,
    };
  },
});
